import { Component } from "@angular/core";
import { DomSanitizer, SafeUrl } from "@angular/platform-browser";
import { SubscriptionService } from "src/app/core/service/subscription.service";
import { SubscriptionDTO } from "src/app/data/schema/Subscriptions/SubscriptionDTO";

@Component({
    selector: "app-profile-use-terms",
    templateUrl: "./profile-use-terms.component.html",
    styleUrls: ["./profile-use-terms.component.scss"]
})
export class ProfileUseTermsComponent {
    public termsOfUse: SafeUrl;

    constructor(
        private readonly subscriptionService: SubscriptionService,
        private readonly domSanitizer: DomSanitizer
    ) {
        this.subscriptionService.currentSubscription$.subscribe((s: SubscriptionDTO) => {
            // console.log(s);
            if (s?.settings.termsOfUseUrl) {
                this.termsOfUse = this.domSanitizer.bypassSecurityTrustResourceUrl(s.settings.termsOfUseUrl);
            }
        });
    }
}
